import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["rerunParserModal", "customPromptInput"]

  openRerunParserModal(e) {
    e.preventDefault()
    $(this.rerunParserModalTarget).modal("show")
  }

  onRerunParserConfirm(e) {
    e.preventDefault()

    const customPrompt = this.customPromptInputTarget.value
    const url = `/manage/snapshots/${this.element.dataset.snapshotId}/reset`

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
          .content,
      },
      body: JSON.stringify({
        from: "start",
        custom_financials_parser_prompt: customPrompt,
      }),
    })
      .then((response) => {
        if (response.ok) {
          $(this.rerunParserModalTarget).modal("hide")
          window.location.href = "/manage/status/snapshots"
        } else {
          console.error("Failed to rerun parser")
        }
      })
      .catch((error) => {
        console.error("Error rerunning parser:", error)
      })
  }
}
